<script>
import axios from 'axios';
import qs from 'qs';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faEllipsisV,
} from '@fortawesome/pro-light-svg-icons';
import {
  faExclamationTriangle,
} from '@fortawesome/pro-solid-svg-icons';

import DmStatusInfoIcon from '@/components/DmStatusInfoIcon.vue';
import DmTransactionRow from '@/components/DmTransactionRow.vue';
import EsSorter from '@/components/EsSorter.vue';
import EsLoader from '@/components/EsLoader.vue';
import EsMenu from '@/components/EsMenu.vue';
import EsPager from '@/components/EsPager.vue';

library.add(
  faEllipsisV,
  faExclamationTriangle,
);

export default {
  props: {
    api: {
      type: String,
    },
    params: {
      type: Object,
    },
    transactionList: {
      type: Array,
    },
    totalCount: {
      type: Number,
    },
    apiSorter: {
      type: Object,
    },
    columnHeaders: {
      type: Array,
      default: () => [
        {
          header: null,
          field: null,
          style: {
            width: '55px',
          },
        },
        {
          header: 'Transaction Info',
          title:'Transaction Info',
          field: null,
          style: {
            width: '20%',
          },
        },
        {
          header: 'Match Type',
          title: 'Match Type',
          field: null,
          style: {
            width: '10%',
          },
        },
        {
          header: 'Location Info',
          title: 'Location Info',
          field: null,
          style: {
            width: '20%',
          },
          hideForTablet: true,
          hideForMobile: true,
        },
        {
          header: 'Process Info',
          title: 'Process Info',
          field: null,
          style: {
            idth: '10%',
          },
        },
        {
          header: 'Batch ID',
          title: 'Batch ID',
          field: null,
          style: {
            width: '10%',
          },
        },
        {
          header: 'Status Info',
          title: 'Status Info',
          field: null,
          hideForMobile: true,
        },
        {
          header: 'Actions',
          title: 'Actions',
          field: null,
          style: {
            width: '1%',
          },
        },
      ],
    },
  },
  components: {
    DmStatusInfoIcon,
    DmTransactionRow,
    EsLoader,
    EsSorter,
    EsMenu,
    EsPager,
  },
  data() {
    return {
      loading: false,
      statuses: [
        'Data Submitted',
        'Validation',
        'Match Processing',
        'Resolution',
        'Match',
      ],
      transactions: [],
    };
  },
  created() {
    if (!this.transactionList) {
      this.getApi();
    } else {
      this.transactions = this.transactionList;
    }
  },
  methods: {
    updateSorter() {
      this.$emit('updateTransactionColumnHeaders');
    },
    async getApi() {
      this.loading = true;
      const res = await axios.get(this.api,
        {
          params: this.params,
          paramsSerializer(params) {
            return qs.stringify(params, { arrayFormat: 'repeat' });
          },
        });
      this.transactions = res.data.data;
      this.loading = false;
    },
  },
}
</script>

<template>
  <table class="table is-fullwidth is-hoverable">
    <es-sorter
      :apiSorter="apiSorter"
      :columnHeaders="columnHeaders"
      @updateSorter="updateSorter"
    />
      </tr>
    </thead>
    <tbody v-if="loading">
      <tr>
        <td colspan="100%" style="text-align: center">
          <es-loader class="has-text-centered" style="margin: 6.5rem"/>
        </td>
      </tr>
    </tbody>
    <dm-transaction-row v-else
      v-for="transaction in transactions" :key="transaction.id"
      :trans="transaction"
    />
    <tfoot v-if="!loading && totalCount">
      <tr>
        <td colspan="100%">
          <es-pager :totalCount="totalCount"/>
        </td>
      </tr>
    </tfoot>
  </table>
</template>

<style lang="sass" scoped>
</style>
